var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageForward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#383636",
    width: 19,
    height: 19,
    viewBox: " 0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.833 5.525L13.687.181a.594.594 0 00-1.021.412v2.573h-.2a7.728 7.728 0 00-7.72 7.719v1.187a.586.586 0 00.462.568.53.53 0 00.131.016.614.614 0 00.542-.338 6.494 6.494 0 015.841-3.61h.94v2.573a.594.594 0 001.021.412l5.146-5.344a.594.594 0 000-.824zm0 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.625 19H2.375a2.378 2.378 0 01-2.379-2.373V5.542a2.378 2.378 0 012.379-2.375H4.75a.792.792 0 110 1.583H2.375a.792.792 0 00-.792.792v11.085a.792.792 0 00.792.792h14.25a.792.792 0 00.792-.792v-6.335a.792.792 0 111.583 0v6.335a2.378 2.378 0 01-2.375 2.375zm0 0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageForward);
export default __webpack_public_path__ + "static/media/message-forward.202ff300.svg";
export { ForwardRef as ReactComponent };